<template>
	<div class="page-order page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="24">
					<h3 style="float: none;">延期管理</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>延期管理</el-breadcrumb-item>
							<el-breadcrumb-item>延期停车列表</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
					
						<el-form-item prop="userName" label="申请人姓名：" style="margin-bottom: 0;">
							<el-input v-model="form_search.userName" size="small" placeholder="请输入申请人姓名" clearable>
							</el-input>
						</el-form-item>
						<el-form-item prop="carNum" label="申请人车牌号：" style="margin-bottom: 0;">
							<el-input v-model="form_search.carNum" size="small" placeholder="请输入申请人车牌号" clearable>
							</el-input>
						</el-form-item>
						<el-form-item prop="userPhoneNumber" label="申请人手机号码：" style="margin-bottom: 0;">
							<el-input v-model="form_search.userPhoneNumber" size="small" placeholder="请输入申请人手机号码" clearable>
							</el-input>
						</el-form-item>
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" size="small" @click='searchList()'>查询</el-button>
              <el-button type="success" size="small" @click="handleExport">导出</el-button>
						</el-form-item>
						<!-- <el-form-item style="color: brown;font-size: 45px;font-weight: bold;">
							订单金额共计:{{sale_amountSum}}元
						</el-form-item> -->
					</el-form>
				</div>
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;">
							<el-table-column prop="imgIds" align="center" label="出差凭证" min-width="80">
							    <template slot-scope="scope">
									<img class="cursor" :src="baseUrl+'/api/sys/file/download?attachId=' + scope.row.imgIds+'&width=300'" height="50" @click="dlg_preview.img_url = baseUrl + '/api/sys/file/download?attachId='+scope.row.imgIds+'&width=300';dlg_preview.visible = true;" title="点击查看" />
							        <!-- <img class="cursor" :src="baseUrl + scope.row.coverImgId" height="23" @click="dlg_preview.coverImgId = baseUrl + scope.row.coverImgId;dlg_preview.visible = true;" title="点击查看" /> -->
							    </template>
							</el-table-column>
							<el-table-column prop="carNum" align="center" label="车牌号" min-width="160">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.carNum">
									</my-textEllipsis>
								</template>
							</el-table-column>
							<!-- <el-table-column prop="waiterId" align="center" label="服务员id" min-width="80">
							</el-table-column> -->
							<el-table-column prop="userName" align="center" label="申请人姓名" min-width="160">
							</el-table-column>
<!--							<el-table-column prop="userOrgName" align="center" label="所属部门" min-width="230">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh"
										:content="scope.row.userOrgName">
									</my-textEllipsis>
								</template>
							</el-table-column>-->
							<el-table-column prop="userPhoneNumber" align="center" label="申请人手机号码" min-width="80">
								<template slot-scope="scope">
									<span class="c-red">{{scope.row.userPhoneNumber}}</span>
								</template>
							</el-table-column>
							
							<el-table-column prop="exHour" align="center" label="申请时长" min-width="200">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.exHour+'小时'"></my-textEllipsis>
								</template>
							</el-table-column>
							<el-table-column prop="createdate"  align="center" label="申请时间"
								min-width="160">
							</el-table-column>
							<el-table-column prop="applyNum"  align="center" label="本次入场申请次数"
								min-width="160">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.applyNum+'次'"></my-textEllipsis>
								</template>
							</el-table-column>
							
							<!-- <el-table-column prop="operating" align="left" label="操作" min-width="300" fixed="right">
								<template slot-scope="scope">
									<el-button class="option-btn btn-bd-m" type="primary" size="mini" @click="goodsDetail(scope.row)">订单详情</el-button>
									
									<el-button v-if="scope.row.orderStatus==1" class="option-btn btn-bd-rm" type="primary" size="mini" @click="cancelOrder(scope.row)">取消订单</el-button>
									<el-button v-if="scope.row.orderStatus==1" class="option-btn btn-bd-rm" type="primary" size="mini" @click="payOrder(scope.row)">手工结账</el-button>
									<el-button  class="option-btn btn-bd-s" type="primary" size="mini" @click="goodsDetailPay(scope.row)">打印结算订单</el-button>
									 
									<el-button v-if="scope.row.orderStatus==3" class="option-btn btn-bd-r" type="primary" size="mini" @click="printCancelOrder(scope.row)">打印取消单</el-button>
									
								</template>
							</el-table-column> -->
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.pageNo" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
				<el-dialog class="dialog-export activity-dialog" :title="dlg_goods.title"
					:visible.sync="dlg_goods.visible" width="360px" :close-on-click-modal="false">
					<el-button  class="option-btn btn-bd-s" type="primary" size="mini" v-print="'#printTest'">打印厨房订单</el-button>
					
					<el-row id="printTest">
						<div style="display: flex;flex-direction: row;justify-content: center;">桌台：{{orderInfoLxc.tableCode}}厨房单</div>
						<div style="display: flex;flex-direction: row;justify-content: center;font-weight: 400;font-size: 12px;margin-top: 10px;">{{orderInfoLxc.createdate}}</div>
						<div style="display: flex;flex-direction: column;justify-content: flex-start;font-weight: 600;color:black;margin-top: 10px;margin-left: 15px">
							<div v-for="(item,index) in dlg_goods.table_data.list" :key="index">
								<div v-if="item.remark !=''" style="color: black;">
									备注{{index+1}}:<span style="margin-left: 10px;margin-bottom: 5px;">{{item.cookName}}:{{item.remark}}</span>
								</div>
							</div>
						</div>
						
						<el-table ref="multipleTable" :data="dlg_goods.table_data.list"
							v-loading="dlg_goods.table_data.loading" max-height="300px" tooltip-effect="dark"
							style="width: 100%;text-align: center;">
							
							<el-table-column prop="cookName" align="center" label="名称" min-width="35%">
								<template slot-scope="scope">
									<span style="color: black;display: flex;flex-wrap: wrap;">{{scope.row.cookName}}</span>
									<!-- <my-textEllipsis v-if="is_refresh" :content="scope.row.cookName" style="display: flex;flex-wrap: wrap;">
									</my-textEllipsis> -->
								</template>
							</el-table-column>
							<!-- <el-table-column prop="image_url" align="center" label="商品图片" min-width="80">
								<template slot-scope="scope">
									<img class="cursor" :src="baseUrl+'/api/sys/file/download?attachId=' + scope.row.coverImgId+'&width=300'" height="23"
										@click="dlg_preview.img_url = baseUrl+'/api/sys/file/download?attachId=' + scope.row.coverImgId+'&width=300';dlg_preview.visible = true;"
										title="点击查看" />
								</template>
							</el-table-column> -->
							
							<el-table-column prop="count" align="center" label="数量" min-width="25%">
								<template slot-scope="scope">
									<span style="color: black">{{scope.row.count}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="cookPrice" style="color: black;" align="center" label="价格" max-width="35%">
								<template slot-scope="scope">
									<span style="color: black">{{scope.row.cookPrice}}</span>
								</template>
							</el-table-column>
							<!-- <el-table-column prop="remark" align="center" label="备注" max-width="30%" style="display: flex;flex-wrap: wrap;">
								<template slot-scope="scope">
									<span style="color: black;display: flex;flex-wrap: wrap;justify-content: center;font-weight: 500;">{{scope.row.remark}}</span>	
									
								</template>
							</el-table-column> -->
						</el-table>
						<div style="display: flex;flex-direction: row;justify-content: center;margin-top: 10px;" v-if="dlg_goods.table_data.addlist.length >0">桌台：{{orderInfoLxc.tableCode}}</div>
						<div style="display: flex;flex-direction: row;justify-content: center;margin-top: 10px;" v-if="dlg_goods.table_data.addlist.length >0">加单{{orderInfoLxc.updatedate}}</div>
						<div style="display: flex;flex-direction: column;justify-content: flex-start;font-weight: 600;color:black;margin-top: 10px;margin-left: 15px">
							<div v-for="(item,index) in dlg_goods.table_data.addlist" :key="index">
								<div v-if="item.remark !=''" style="color: black;">
									备注{{index+1}}:<span style="margin-left: 10px;margin-bottom: 5px;">{{item.cookName}}:{{item.remark}}</span>
								</div>
							</div>
						</div>
						<el-table v-if="dlg_goods.table_data.addlist.length >0" ref="multipleTableAdd" :data="dlg_goods.table_data.addlist"
							v-loading="dlg_goods.table_data.loading" max-height="300px" tooltip-effect="dark"
							style="margin-top: 30px;width: 100%;text-align: center;">
							
							<el-table-column prop="cookName" align="center" label="名称"  min-width="35%">
								
								<template slot-scope="scope">
									<span style="display: flex;flex-wrap: wrap;color: black">{{scope.row.cookName}}</span>
									<!-- <my-textEllipsis v-if="is_refresh" :content="scope.row.cookName">
									</my-textEllipsis> -->
								
								</template>
							</el-table-column>
						<!-- 	<el-table-column prop="statusText" align="center" label="加单" class="addTitle" min-width="120">
								<template slot-scope="scope">
									<span class="addTitle">{{scope.row.statusText}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="image_url" align="center" label="商品图片" min-width="80">
								<template slot-scope="scope">
									<img class="cursor" :src="baseUrl+'/api/sys/file/download?attachId=' + scope.row.coverImgId+'&width=300'" height="23"
										@click="dlg_preview.img_url = baseUrl+'/api/sys/file/download?attachId=' + scope.row.coverImgId+'&width=300';dlg_preview.visible = true;"
										title="点击查看" />
								</template>
							</el-table-column> -->
							
							<el-table-column prop="count" align="center" label="数量"  min-width="25%">
								<template slot-scope="scope">
									<span style="color: black;">{{scope.row.count}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="cookPrice" align="center"  style="color: black;" label="价格"   max-width="35%">
								<template slot-scope="scope">
									<span style="color: black">{{scope.row.cookPrice}}</span>
								</template>
							</el-table-column>
							<!-- <el-table-column  prop="remark" align="center" label="备注" min-width="40">
								<template slot-scope="scope">
									<span style="color: black;display: flex;flex-wrap: wrap;justify-content: center;font-weight: 500;">{{scope.row.remark}}</span>	
									
								</template>
							</el-table-column> -->
						</el-table>
						<div style="display: flex;flex-direction: row;justify-content: center;margin-top: 10px;" v-if="dlg_goods.table_data.deletelist.length >0">桌台：{{orderInfoLxc.tableCode}}</div>
						<div style="display: flex;flex-direction: row;justify-content: center;margin-top: 10px;" v-if="dlg_goods.table_data.deletelist.length >0">减单{{orderInfoLxc.updatedate}}</div>
						<div style="display: flex;flex-direction: column;justify-content: flex-start;font-weight: 600;color:black;margin-top: 10px;margin-left: 15px">
							<div v-for="(item,index) in dlg_goods.table_data.deletelist" :key="index">
								<div v-if="item.remark !=''" style="color: black;">
									备注{{index+1}}:<span style="margin-left: 10px;margin-bottom: 5px;">{{item.cookName}}:{{item.remark}}</span>
								</div>
							</div>
						</div>
						<el-table v-if="dlg_goods.table_data.deletelist.length >0" ref="multipleTableDel" :data="dlg_goods.table_data.deletelist"
							v-loading="dlg_goods.table_data.loading" max-height="600px" tooltip-effect="dark"
							style="margin-top: 30px;width: 100%;text-align: center;">
							<el-table-column prop="cookName" align="center" label="名称"  min-width="35%" class="flex-block">
									<template slot-scope="scope">
										<span style="display: flex;flex-wrap: wrap;color: black">{{scope.row.cookName}}</span>
										
									</template>
							</el-table-column>
								<!-- <el-table-column prop="statusText" align="center" label="减单" class="addTitle" min-width="120">
									<template slot-scope="scope">
										<span class="delTitle">{{scope.row.statusText}}</span>
									</template>
								</el-table-column>
							<el-table-column prop="image_url" align="center" label="商品图片" min-width="80">
								<template slot-scope="scope">
									<img class="cursor" :src="baseUrl+'/api/sys/file/download?attachId=' + scope.row.coverImgId+'&width=300'" height="23"
										@click="dlg_preview.img_url = baseUrl+'/api/sys/file/download?attachId=' + scope.row.coverImgId+'&width=300';dlg_preview.visible = true;"
										title="点击查看" />
								</template>
							</el-table-column> -->
							
							<el-table-column prop="count" align="center" label="数量"  min-width="28%">
								<template slot-scope="scope">
									<span  style="color: black;">{{scope.row.count}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="cookPrice" align="center" style="color: black;" label="价格"   max-width="35%">
								<template slot-scope="scope">
									<span style="color: black">{{scope.row.cookPrice}}</span>
								</template>
								
							</el-table-column>
							<!-- <el-table-column prop="remark" align="center" label="备注" max-width="40">
								<template slot-scope="scope">
									<span style="color: black;display: flex;flex-wrap: wrap;justify-content: center;font-weight: 500;">{{scope.row.remark}}</span>	
									
								</template>
							</el-table-column> -->
						</el-table>
						
					</el-row>
				</el-dialog>
				<el-dialog class="dialog-export activity-dialog" :title="dlg_goods_pay.title"
					:visible.sync="dlg_goods_pay.visible" width="360px" :close-on-click-modal="false">
					<el-button  class="option-btn btn-bd-s" type="primary" size="mini" v-print="'#printTestPay'">打印结算订单</el-button>
					
					<el-row id="printTestPay">
						<div style="display: flex;flex-direction: row;justify-content: center;">桌台：{{orderInfoLxc.tableCode}}结算单</div>
						<div style="display: flex;flex-direction: row;justify-content: center;font-weight: 400;font-size: 12px;margin-top: 10px;">{{orderInfoLxc.createdate}}</div>
						<el-table ref="multipleTable" :data="dlg_goods_pay.table_data.list"
							v-loading="dlg_goods_pay.table_data.loading" max-height="300px" tooltip-effect="dark"
							style="width: 100%;text-align: center;">
							
							<el-table-column prop="cookName" align="center" label="名称" min-width="35%">
								<template slot-scope="scope">
									<span style="color: black;display: flex;flex-wrap: wrap;">{{scope.row.cookName}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="count" align="center" label="数量" min-width="25%">
								<template slot-scope="scope">
									<span style="color: black">{{scope.row.count}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="cookPrice" style="color: black;" align="center" label="价格" max-width="35%">
								<template slot-scope="scope">
									<span style="color: black">{{scope.row.cookPrice}}</span>
								</template>
							</el-table-column>
						</el-table>
						<!-- <div style="display: flex;flex-direction: row;justify-content: center;margin-top: 10px;" v-if="dlg_goods.table_data.addlist.length >0">桌台：{{orderInfoLxc.tableCode}}</div> -->
						<div style="display: flex;flex-direction: row;justify-content: center;margin-top: 10px;" v-if="dlg_goods.table_data.addlist.length >0">加单{{orderInfoLxc.updatedate}}</div>
						
						<el-table v-if="dlg_goods.table_data.addlist.length >0" ref="multipleTableAdd" :data="dlg_goods.table_data.addlist"
							v-loading="dlg_goods.table_data.loading" max-height="300px" tooltip-effect="dark"
							style="margin-top: 30px;width: 100%;text-align: center;">
							
							<el-table-column prop="cookName" align="center" label="名称"  min-width="35%">
								<template slot-scope="scope">
									<span style="display: flex;flex-wrap: wrap;color: black">{{scope.row.cookName}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="count" align="center" label="数量"  min-width="25%">
								<template slot-scope="scope">
									<span style="color: black;">{{scope.row.count}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="cookPrice" align="center"  style="color: black;" label="价格"   max-width="35%">
								<template slot-scope="scope">
									<span style="color: black">{{scope.row.cookPrice}}</span>
								</template>
							</el-table-column>
						</el-table>
						<!-- <div style="display: flex;flex-direction: row;justify-content: center;margin-top: 10px;" v-if="dlg_goods.table_data.deletelist.length >0">桌台：{{orderInfoLxc.tableCode}}</div> -->
						<div style="display: flex;flex-direction: row;justify-content: center;margin-top: 10px;" v-if="dlg_goods.table_data.deletelist.length >0">减单{{orderInfoLxc.updatedate}}</div>
						
						<el-table v-if="dlg_goods.table_data.deletelist.length >0" ref="multipleTableDel" :data="dlg_goods.table_data.deletelist"
							v-loading="dlg_goods.table_data.loading" max-height="600px" tooltip-effect="dark"
							style="margin-top: 30px;width: 100%;text-align: center;">
							<el-table-column prop="cookName" align="center" label="名称"  min-width="35%" class="flex-block">
									<template slot-scope="scope">
										<span style="display: flex;flex-wrap: wrap;color: black">{{scope.row.cookName}}</span>
										
									</template>
							</el-table-column>
							<el-table-column prop="count" align="center" label="数量"  min-width="28%">
								<template slot-scope="scope">
									<span  style="color: black;">{{scope.row.count}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="cookPrice" align="center" style="color: black;" label="价格"   max-width="35%">
								<template slot-scope="scope">
									<span style="color: black">{{scope.row.cookPrice}}</span>
								</template>
							</el-table-column>
						</el-table>
						<div style="display: flex;flex-direction: row;justify-content: flex-end;color: black;font-weight: 600;margin-top: 20px;margin-right: 15px;">共计消费金额:{{orderInfoLxc.amount}}元</div>
					</el-row>
				</el-dialog>
				<el-dialog class="dialog-export cancel-dialog" :title="dlg_cancel.title"
					:visible.sync="dlg_cancel.visible" width="350px" @closed="closeCancel"
					:close-on-click-modal="false">
					<el-button v-if="orderInfoLxc.orderStatus ==3" class="option-btn btn-bd-s" type="primary" size="mini" v-print="'#printTestCancel'">打印取消单</el-button>
					<div id="printTestCancel" style="padding: 10px;">
						<div style="display: flex;flex-direction: row;justify-content: center;">桌台：{{orderInfoLxc.tableCode}}取消单</div>
						<div style="display: flex;flex-direction: row;justify-content: center;font-weight: 400;font-size: 12px;margin-top: 10px;margin-bottom: 10px;">{{orderInfoLxc.createdate}}</div>
						
						<el-form ref="formCancel" :model="dlg_cancel.form" :rules="dlg_cancel.rules"
							@submit.native.prevent>
							<!-- <el-form-item prop="feedback" style="color: black;" label="取消原因：">
								
							</el-form-item> -->
							<div style="color: black;margin-bottom: 15px;">取消原因：</div>
							<el-input v-model="dlg_cancel.form.feedback"  style="border: 1px solid #000;" type="textarea" :rows="6" size="small"
								placeholder="请输入取消原因"></el-input>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dlg_cancel.visible = false">关 闭</el-button>
						<el-button v-if="orderInfoLxc.orderStatus !=3" type="primary" @click="submitCancel()" :loading="dlg_cancel.btn_loading">确认取消
						</el-button>
					</span>
				</el-dialog>
				<el-dialog class="dialog-export cancel-dialog" :title="dlg_pay.title"
					:visible.sync="dlg_pay.visible" width="534px" @closed="closePay()"
					:close-on-click-modal="false">
					<el-form ref="formCancel" :model="dlg_pay.form" label-width="110px" :rules="dlg_pay.rules"
						@submit.native.prevent>
						<el-form-item prop="feedback" label="用餐体验：">
							<el-input v-model="dlg_pay.form.feedback" type="textarea" :rows="3" size="small"
								placeholder="请输入客户用餐体验"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dlg_pay.visible = false">关 闭</el-button>
						<el-button type="primary" @click="submitPay()" :loading="dlg_pay.btn_loading">确认结算
						</el-button>
					</span>
				</el-dialog>

				<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
					<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
				</el-dialog>
				
			</div>
		</div>
	</div>
</template>
<script>
  import config from '@/assets/js/config';
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				baseUrl: this.$client.IMG_URL,
				body_loading: false,
				is_refresh: true,
				create_range: '',
				form_search: {
					
					userName: '',
					carNum: "",
					userPhoneNumber:"",
					
				},
				init_data: {
					desk_list: [],
					order_mode_list: [],
					status_list: [
						{id:1, name: '未结账'},{id:2, name: '已结账'},{id:3, name: '已取消'}
					]
				},
				table_data: {
					loading: false,
					list: [],
					page_info: {
						pageNo: 1,
						pageSize: 10,
						total: 130
					}
				},
				dlg_goods: {
					title: '订单详情',
					visible: false,
					consignee: '',
					consignee_addr: '',
					consignee_phone: '',
					table_data: {
						loading: false,
						list: [],
						addlist:[],
						deletelist:[]
					}
				},
				dlg_goods_pay:{
					title: '订单详情',
					visible: false,
					consignee: '',
					consignee_addr: '',
					consignee_phone: '',
					table_data: {
						loading: false,
						list: [],
						addlist:[],
						deletelist:[]
					}
				},
				dlg_cancel: {
					title: '取消订单',
					visible: false,
					form: {
						id: '',
						feedback: ''
					}
				},
				dlg_pay: {
					title: '结算订单',
					visible: false,
					form: {
						id: '',
						feedback: ''
					}
				},
				dlg_preview: {
					visible: false,
					img_url: ''
				},
				// 销售金额统计
				sale_amountSum:'',
				orderInfoLxc:{}
			}
		},
		created() {
			document.title = '延期申请列表';
			this.getList();
			//this.getSaleAmountSum()
			//this.getDeskList()
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.pageNo = 1;
				_this.getList();
			//	_this.getSaleAmountSum()
			},
      handleExport() {
        var _this = this;
        var params = {
          userName: _this.form_search.userName,
          carNum: _this.form_search.carNum,
          userPhoneNumber: _this.form_search.userPhoneNumber,
        };
        var queryString = Object.keys(params).map(key => params[key] !== '' ? `${key}=${encodeURIComponent(params[key])}` : '').filter(Boolean).join('&');
        if (queryString) {
          queryString += '&'
        }
        console.log(queryString);
        window.open(config.api_url + '/api/biz/parking/extension/exportListForAdmin?' + queryString + 'token=' + localStorage.getItem('token') + '&loginFrom=pc', '_blank');
      },
			
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.pageNo = _this.table_data.page_info.pageNo;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				this.$client.get('/api/biz/parking/extension/getListForAdmin', params, function(res, message,total,totalPages) {
					_this.table_data.list = res;
					//_this.table_data.page_info.page = totalPages;
					_this.table_data.page_info.total = total;
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
				this.table_data.page_info.pageSize = val;
				this.getList();
				this.getSaleAmountSum()
			},
			handleCurrentChange(val) {
				//console.log(`当前页: ${val}`);
				this.table_data.page_info.pageNo = val;
				this.getList();
				this.getSaleAmountSum()
			},
			getOrderDetail(id) {
				var _this = this;
				_this.table_data.loading = true;
				this.$client.get('/api/biz/order/getModelEx', {id:id}, function(res, message) {
					_this.orderInfoLxc=res
					_this.dlg_goods.table_data.list = res.listDetail;
					_this.dlg_goods.table_data.addlist=res.listDetailAdd;
					_this.dlg_goods.table_data.deletelist=res.listDetailDelete
					_this.dlg_goods_pay.table_data.list= res.listDetail;
					_this.dlg_goods_pay.table_data.addlist=res.listDetailAdd;
					_this.dlg_goods_pay.table_data.deletelist=res.listDetailDelete
					
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			goodsDetail(data) {
				//请求详情接口
				this.getOrderDetail(data.icode)
                this.dlg_goods.visible = true;
				this.dlg_goods.title = '订单详情---' + '此订单状态：' + data.orderStatusText ;
			},
			goodsDetailPay(data) {
				//请求详情接口
				this.getOrderDetail(data.icode)
			    this.dlg_goods_pay.visible = true;
				this.dlg_goods_pay.title = '订单详情---' + '此订单状态：' + data.orderStatusText ;
			},
			printAll(data) {
				var _this = this;
				// var params = {
				// 	orderId: data.icode
				// };
				 this.$print(this.$refs.print, {
				        'no-print': '.do-not-print-me-xxx'
				    });
			},
			//手工结账
			payOrder(data){
				this.dlg_pay.visible = true;
				this.dlg_pay.title = '结算-' + data.tableCode + '-' + data.createdate + ' 下的订单';
				this.dlg_pay.form.id = data.icode;
			},
			submitPay() {
				var _this = this;
				this.$client.post('/api/biz/order/settleAccounts', this.dlg_pay.form, function(res, message) {
					_this.$message(message);
					_this.dlg_pay.visible = false;
					_this.getList();
					_this.getSaleAmountSum()
				}, function(res) {
				});
			},
			closePay() {
				this.dlg_pay.form.id = '';
				this.dlg_pay.form.feedback = '';
			},
			cancelOrder(data) {
				this.getOrderDetail(data.icode)
				this.dlg_cancel.visible = true;
				this.dlg_cancel.title = '取消-' + data.tableCode + '-' + data.createdate + ' 下的订单';
				this.dlg_cancel.form.id = data.icode;
			},
			printCancelOrder(data){
				this.getOrderDetail(data.icode)
				this.dlg_cancel.visible = true;
				this.dlg_cancel.title = '取消-' + data.tableCode + '-' + data.createdate + ' 下的订单';
				this.dlg_cancel.form.id = data.icode;
				this.dlg_cancel.form.feedback=data.feedback
			},
			submitCancel() {
				var _this = this;
				this.$client.post('/api/biz/order/cancel', this.dlg_cancel.form, function(res, message) {
					_this.$message(message);
					_this.dlg_cancel.visible = false;
					_this.getList();
					_this.getSaleAmountSum()
				}, function(res) {
				});
			},
			closeCancel() {
				this.dlg_cancel.form.id = '';
				this.dlg_cancel.form.feedback = '';
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			},
			create_range(newVal) {
				//console.log(newVal);
				if (newVal == null) {
					this.form_search.searchStartDate = '';
					this.form_search.searchEndDate = '';
				} else {
					this.form_search.searchStartDate = newVal[0];
					this.form_search.searchEndDate = newVal[1];
				}
			}
		}
	}
</script>
<style>

</style>
<style scoped>
	.status-2 {
		color: #9a9a9a;
	}

	.status-1 {
		color: #F31A5C;
	}

	.status-0 {
		color: #F27918;
	}

	.status-3 {
		color: #0C67F0;
	}

	.status-9 {
		color: #04B365;
	}

	.status-10 {
		color: #666;
	}
	.option-btn {
		margin: 5px;
	}
	.row_flex{
		display: flex;
		flex-direction: row;
		
	}
	.addTitle{
		color: crimson;
		border:2rpx solid crimson;
		
		border-radius: 10rpx;
		padding: 5rpx 20rpx;
	}
	.delTitle{
		color: green;
		border:2rpx solid green;
		margin-left: 40rpx;
		border-radius: 10rpx;
		padding: 5rpx 20rpx;
	}
	.el-table th.el-table__cell>.cell  {
		color: black !important;
	}
	.dialog-export .el-dialog__body.el-table td{
		color: black !important;
	}
	.el-textarea__inner{
		    color: #000;
		    background-color: #FFF;
		    border: 1px solid #000;
		    border-radius: 4px;
	}
	
</style>
